module.exports = __webpack_public_path__ + "media/images/regions_old/Tillaberi-6aa7f5c5e4aca7a29e1955e3e9fa14f9.png";